export const checkinModalGlobal = {
  header: {
    phone: "Telefon",
    accommodation: "Unterkunft",
    checkin: "Check-in",
    booking: "Buchung",
    notAvailable: "Nicht verfügbar",
    notLinked: "Nicht verknüpft",
    defaultGuestName: "Gast",
  },
  roles: {
    botStaff: "BOT / TEAM",
    guest: "GAST",
  },
  media: {
    imageAlt: "Gesendetes Bild",
    locationReceived: "📍 Standort empfangen",
    openInMaps: "In Google Maps öffnen",
    viewCoordinates: "Koordinaten ansehen ({lat}, {lng})",
    viewFile: "Datei ansehen",
    document: "Dokument",
  },
  dropzone: {
    text: "Zum Anhängen hier ablegen",
  },
  failure: {
    notSent: "Nicht gesendet",
    notSentDefault: "Nicht gesendet",
    reasons: {
      paymentIssue: "Zahlungsproblem beim WhatsApp-Konto",
      cannotReceive: "die Nummer kann kein WhatsApp empfangen",
      downloadFailed: "WhatsApp konnte die Datei nicht herunterladen",
      templateMissingData: "in der Vorlage fehlen Daten",
      requirementsNotMet: "die Nachricht erfüllt nicht die Anforderungen von WhatsApp",
    },
  },
  mode: {
    ai: "KI",
    manual: "Manuell",
    autoReplyBanner: "Der Agent antwortet diesem Gast automatisch.",
  },
  predefined: {
    header: "Vordefinierte Antworten",
    empty: "Keine vordefinierten Antworten gefunden",
  },
  input: {
    attachFile: "Datei anhängen",
    placeholder: "Mit / beginnen, um eine vordefinierte Antwort zu wählen.",
    removeFile: "Datei entfernen",
  },
  toasts: {
    noBookingLinkedSummary: "Keine Buchung verknüpft",
    noBookingLinkedDetail: "Zu diesem Gespräch gibt es keine zugehörige Buchung",
    errorSummary: "Fehler",
    userIdError: "Die Benutzer-ID konnte nicht ermittelt werden",
    manualModeSummary: "Manueller Modus aktiviert",
    aiModeSummary: "KI-Agent aktiviert",
    manualModeDetail: "Sie beantworten die Nachrichten manuell",
    aiModeDetail: "Der Bot antwortet automatisch",
    modeChangeError: "Der Chat-Modus konnte nicht geändert werden",
    reactivateIdError: "Das Gespräch für die Reaktivierung konnte nicht ermittelt werden.",
    successSummary: "Erfolg",
    templateSentOk: "Vorlage erfolgreich gesendet.",
    templateSentError: "Die Reaktivierungsvorlage konnte nicht gesendet werden.",
    fileTypeSummary: "Dateityp nicht zulässig",
    fileTypeDetail: "{name} ist kein Bild und kein PDF.",
    fileSizeSummary: "Datei zu groß",
    fileSizeDetail: "{name} überschreitet das Limit von 5 MB.",
    sendError: "Die Nachricht konnte nicht gesendet werden",
  },
};
